/**
 * Syncs auth + router context into Sentry (Pillar 4 observability).
 * Must render inside BrowserRouter and AuthProvider.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import { useAuth } from '@healthdesk/shared-hooks';

export default function SentryContextSync() {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;

    const path = `${location.pathname}${location.search || ''}`;
    Sentry.addBreadcrumb({
      category: 'navigation',
      message: path,
      level: 'info',
    });
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') return;

    if (user && !user.isAnonymous) {
      Sentry.setUser({ id: user.uid });
    } else {
      Sentry.setUser(null);
    }
  }, [user]);

  return null;
}
